<template>
  <ion-page>
    <!-- <ion-header> -->
    <div class="overlay" v-if="currentTab !== 'match-detail'">
      <ion-toolbar class='header-bar'>
        <ion-buttons slot="start" @click="openMenu()">
          <div class="pl-05 pointer">
            <ion-icon :icon="menuSharp" />
          </div>
        </ion-buttons>
        <div class="d-flex">
          <ion-title  size="medium">{{appTitle}}</ion-title>
        </div>
      </ion-toolbar>
    </div>
    <div class="overlay" v-if="!compListOpen && ['schedule', 'ladder', 'leaderboard'].includes(currentTab)">
      <ion-item >
        <ion-label>Seasons</ion-label>
        <ion-select placeholder="Select One" v-model="filterSeason">
          <ion-select-option v-for="season in seasons" :key="season._id" :value="season._id">{{ season._id }}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label>Level</ion-label>
        <ion-select placeholder="Select Entity Level" v-model="selectedEntityType">
          <ion-select-option v-for="level in entityLevels" :key="level.value" :value="level.name">{{ level.name }}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label>Entity</ion-label>
        <ion-select placeholder="Select Entity" v-model="selectedEntityIds" multiple>
          <ion-select-option v-for="entity in entities" :key="entity._id" :value="entity._id">{{ entity.name }}</ion-select-option>
        </ion-select>
      </ion-item>

      <div class="d-flex justify-end mt-10 px-20 pointer hover-underline" v-if="selectedEntityType">
        <small class="hover-underline c-gray" @click="clearFilters">Clear Filters</small>
      </div>

      <ion-toolbar>
        <ion-buttons slot="start" class="pl-20 pointer">
          <ion-icon :icon="caretDownOutline" @click="compListOpen = true"/>
        </ion-buttons>
        <ion-grid :scroll-x="true" class="competition-row ml-10" style="{'white-space': 'nowrap', 'padding-top': '1rem', background: $background !important}" nowrap>
          <ion-chip v-for="{_id, name} in competitions" :id="`competition-${_id}`" :key="_id" @click="competitionId = _id" :class="{
            'mr-10': true,
            chip: true,
            active: competitionId === _id,
            selectable: competitionId !== _id
          }">
            <ion-label>{{ name }}</ion-label>
          </ion-chip>
        </ion-grid>
      </ion-toolbar>
    </div>
    <!-- </ion-header> -->
    <ion-content class="" v-if="!compListOpen && !loading">
      <div v-if="currentTab === 'ladder'" class="flex flex-column justify-center" style="width:100%;">
        <Ladder v-if="displayLadders && ladder.competition" :key="key" :ladder="ladder" :sportLadder="sportLadder"/>
        <div v-else-if="displayLadders === false" class="empty-container" >
          <ion-card>
            <ion-text color="secondary">
              <h1 class="empty-placeholder">Ladders Not Available to Public</h1>
            </ion-text>
          </ion-card>
        </div>
        <div v-else class="empty-container" >
          <ion-card>
            <ion-text color="secondary">
              <h1 class="empty-placeholder">No Ladder Available</h1>
            </ion-text>
          </ion-card>
        </div>
      </div>
    </ion-content>
    <ion-content v-else-if="!loading">
      <ion-text><h1 class="round-text text-center">COMPETITIONS</h1></ion-text>
      <ion-list>
        <ion-item v-for="{_id, name} in competitions" :key="_id" @click="competitionId = _id; compListOpen = false" >
          <ion-label>{{ name }}</ion-label>
          <!-- tick if selected -->
          <ion-checkbox slot="end" v-if="competitionId === _id" checked="true"></ion-checkbox>
        </ion-item>
      </ion-list>

    </ion-content>

    <ion-content v-else>
      <Skeleton />
    </ion-content>

  </ion-page>
</template>

<script>
import {
  ellipsisVertical,
  personCircle,
  flagOutline,
  podiumOutline,
  arrowBackOutline,
  arrowForwardOutline,
  caretDownOutline,
  menuSharp
} from "ionicons/icons";
import { loadingController, menuController } from "@ionic/vue";
import Ladder from '../components/Ladder';
import Skeleton from '../components/Skeleton';
import {weatherCodes} from '@/utils/constants';
import { mapGetters } from "vuex";
import _ from 'lodash';
import moment from 'moment';

const fetchWeather = async (matches) => {
  const baseUrl = 'https://api.tomorrow.io/v4/timelines?';

  const weatherData = []; // rego _id, data
  for (const match of matches) {
    const address = _.get(match, 'venue.address');
    const startDate = _.get(match, 'dateTime');

    const weather = weatherData.find((w) => w._id === match._id);
    if (!address || !startDate) {
      match.weather = {};
    } else if (weather) {
      match.weather = weather.data;
    } else {
      const { lat, lng } = address;
      const query = {
        location: [lat, lng],
        fields: ['weatherCode', 'temperature'],
        timesteps: '1d',
        units: 'metric',
        apikey: process.env.VUE_APP_WEATHER_API_KEY,
        startTime: moment(startDate).startOf('day').toISOString(),
        endTime: moment(startDate).add(2, 'days').toISOString()
      };
      const queryString = new URLSearchParams(query).toString();
      const url = `${baseUrl}${queryString}`;
      // eslint-disable-next-line no-await-in-loop
      await fetch(url).then((r) => r.json()).then((res) => {
        const wData = _.get(res, 'data.timelines[0].intervals[1].values', {});
        // const wData = {
        //   weatherCode: 1000,
        //   temperature: 20.44
        // };
        if (wData.weatherCode) {
          wData.base = _.find(weatherCodes, (c) => c.value === wData.weatherCode) || {};
        }
        weatherData.push({ _id: match._id, data: wData });
        match.weather = wData;
      }).catch(() => {
        match.weather = {};
      });
    }
  }
  // return matches;
};

export default {
  components: {
    Ladder,
    Skeleton,
  },
  setup() {
    return {
      flagOutline,
      podiumOutline,
      arrowBackOutline,
      arrowForwardOutline,
      caretDownOutline,
      menuSharp
    }
  },
  data() {
    const { filter } = this.$store.state.matches;
    return {
      slideOpts: {
        initialSlide: 1,
        speed: 400,
        navigation: false,
        pagination: false,
        centerInsufficientSlides: true,
        // slidesPerView: 4,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 4,
            spaceBetween: 30
          },
          // when window width is >= 640px
          640: {
            slidesPerView: 5,
            spaceBetween: 40
          }
        }
      },
      compListOpen: false,
      dateFilter: false,
      filterSeason: moment().year(),
      upperCase: _.upperCase,
      get: _.get,
      find: _.find,
      ellipsisVertical,
      personCircle,
      competitions: [],
      competitionId: undefined,
      round: filter.round,
      team: filter.team,
      ladder: {},
      eventLadder: {},
      filter,
      key: 0,
      loading: true,
      ladderSegment: 'ladderBoard',
      eventType: undefined,
      displayMatches: true,
      displayLadders: true,
      sportLadder: {
        headers: [],
        rows: [],
        label: 'Ladder'
      },
      sportType: 'soccer',
      entityLevels: [
        { name: 'State', value: 'state' },
        { name: 'Association', value: 'association' },
        { name: 'Club', value: 'club' },
        { name: 'Team', value: 'team' },
      ],
      entities: [
      ],
      selectedEntityType: 'state',
      selectedEntityIds: [],
    };
  },
  updated() {
    // const uiCompId = this.$store.getters['ui/competitionId'];
    // if (uiCompId) {
    //   this.competitionId = uiCompId;
    // }
    // const uiSeason = this.$store.getters['ui/season'];
    // if (uiSeason) {
    //   this.filterSeason = uiSeason;
    // }
  },
  async beforeMount() {
    this.$store.commit('matches/setCurrentTab', 'ladder');
    try {
      this.loading = true;
      let resComps;
      if(this.entity && this.entity._id){
        resComps = await this.$http.get("/assemble/api/v1/live/competitions",{params:{entityType:this.entity.level,entityId:this.entity._id,season:this.filterSeason}});
      }
      else{
        resComps = await this.$http.get("assemble/api/v1/live/competitions", {
          params:{
            season: this.filterSeason
          }
        });
      }

      this.competitions = resComps.data.data;
      if(this.scoringTypes && this.scoringTypes.length > 0) {
        this.eventType = this.scoringTypes[0].type;
      }
      const uiCompId = this.$store.getters['ui/competitionId'];
      if (uiCompId) {
        this.competitionId = uiCompId;
      } else if (this.competitions.length) {
        this.competitionId = this.competitions[0]._id;
      }
      const uiSeason = this.$store.getters['ui/season'];
      if (uiSeason) {
        this.filterSeason = uiSeason;
      }
      await this.customArrange();
    } catch (error) {
      console.log(error);
    }
  },
  computed: {
    ...mapGetters('matches', ['currentTab']),
    scoringTypes(){
      const types = this.$store.state.national.scoringEvents;
      return types.filter(type => type.visibleInLadders !== false);
    },
    entity() {
      return this.$store.getters['national/getEntity'];
    },
    appTitle() {
      const meta = this.$store.getters['national/getMeta'];
      if (meta && meta.name) return meta.name;
      return process.env.VUE_APP_BANNER_TITLE;


    },
    seasons(){
      const seasons =  this.$store.state.national.seasons;
      if(seasons && seasons.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.filterSeason = seasons.find(season => season.currentSeason )._id;
      }
      return seasons
    }
  },
  methods: {
    clearFilters() {
      this.selectedEntityIds = [];
      this.selectedEntityType = null;
      // this.filterSeason = undefined;
    },
    customArrange() {
      const nationalId = process.env.VUE_APP_NATIONAL_ID;
      const {competitions, seasons} = this;
      const currentSeason = _.find(seasons, {'currentSeason': true});
      let arrangementId = [];
      let arranged = [];
      if (competitions && nationalId === "8") {
        if (_.get(currentSeason, '_id') === 2022) {
          // arrangementName = [
          //   'Superliga e Meshkujve',
          //   'Superliga e Femrave',
          //   'Liga e Parë Meshkujt',
          //   'Liga e Parë Femrat',
          //   'Liga e Kadetëve (M)',
          //   'Liga e Kadeteve (F)',
          //   'Liga e Fatosëve',
          //   'Liga e Fatoseve',
          //   'Kupa e Kosovës (M)',
          //   'Kupa e Kosovës (F)',
          // ];
          arrangementId = [
            300140,
            300141,
            300124,
            300125,
            300138,
            300130,
            300131,
            300128,
            300129,
            300135,
            300136,
            300133,
            300134,
          ];
          arrangementId.forEach((item, i) => {
            const comp = _.find(competitions, {'_id': item});
            if (!comp) {
              return
            }
            arranged.push(comp);
          });
          const compNotInList = _.filter(competitions, (c) => !arrangementId.includes(c._id));
          compNotInList.forEach((item, i) => {
            arranged.push(item);
          });
          this.competitions = arranged;
          this.competitionId = _.get(this.competitions[0], '_id');
        }
      }
    },
    openMenu() {
      // menuController.enable(true, 'side');
      console.log('openMenu');
      menuController.open('side');
    },
    // getWeatherIcon(name) {
    //   var images = require.context('../assets/weather-icons/', false, /\.svg$/)
    //   return images('./' + name + ".svg")
    // },
    goMatch(id) {
      console.log('entity', this.entity);
      if(this.entity && this.entity.level && this.entity.name){
        this.$router.push(`/c/${this.entity.level}/${this.entity.name}/matches/${id}`);
        return;
      }
      this.$router.push(`/matches/${id}`);
    },
    goToAS() {
      window.open('https://assemblesports.com', "_blank");
    },
    randomizeAds() {
      const freq = 5;
      const rand =  Math.random();
      return rand  <= (freq / 100);
    },
  },
  watch: {
    competitionId: {
      async handler(id) {
        if(!id) return;
        if (this.currentTab === 'ladder') {
          if (this.loading === true) return;
          this.loading = true;
          this.ladder = {};
          const resLadder = await this.$httpNoAuth.get(`/assemble/api/v1/live/ladders/competition/${id}`)
          const competition = _.find(this.competitions, c => _.get(c, '_id') === id);
          this.displayLadders = _.get(competition, 'display.ladder');
          this.ladder = Object.assign(this.ladder, resLadder.data.data)
          const matchDetails = this.$store.getters['match/matchDetails'];
          this.sportType = this.sportType = _.get(matchDetails, 'sportType.value', -1);
          const sportLadder = await this.$httpNoAuth.get(`/assemble/api/v1/live/ladders/competition/${id}/sport/`);
          this.sportLadder = _.get(sportLadder, 'data.data.tableData');
        }
        this.loading = false;
        // await fetchWeather(this.matches)
        this.$store.dispatch('ui/updateCompetitionId', {
          competitionId: id
        });
      },
      immediate: true,
    },
    filterSeason: {
      async handler(id) {
        if(!id) return;
        try {
          if (this.loading === true) return;
          this.loading = true;
          let resComps;
          if(this.entity && this.entity._id){
            resComps = await this.$http.get("/assemble/api/v1/live/competitions",{params:{entityType:this.entity.level,entityId:this.entity._id,season:this.filterSeason}});
          }
          else{
            resComps = await this.$http.get("assemble/api/v1/live/competitions", {
              params:{
                season: this.filterSeason
              }
            });
          }
          this.competitions = resComps.data.data;
          this.ladder = {};
          if(this.scoringTypes && this.scoringTypes.length > 0) {
            this.eventType = this.scoringTypes[0].type;
          }
          if (this.filterSeason != id) {
            this.competitionId = undefined;
            if (this.competitions.length) this.competitionId = this.competitions[0]._id;
          }
          if (this.currentTab === 'ladder' && this.competitionId) {
            this.loading = true;
            this.ladder = {};
            const resLadder = await this.$httpNoAuth.get(`/assemble/api/v1/live/ladders/competition/${this.competitionId}`)
            this.ladder = Object.assign(this.ladder, resLadder.data.data)
          }
          this.loading = false;
        } catch (error) {
          console.log(error);
        }

        this.loading = false;
        // await fetchWeather(this.matches)
        this.customArrange();
        // this.$store.dispatch('ui/updateSeason', {
        //   season: id
        // });
      },
      immediate: true,
    },
    selectedEntityType: {
      handler: async function(val) {
        this.loading = true;
        if (val) {
          this.selectedEntityIds = [];
          this.competitionId = undefined;
          const entityRes = await this.$http.get(`/assemble/api/v1/live/${val}s`);
          this.entities = entityRes.data.data;
        }
        this.loading = false;
      },
    },
    selectedEntityIds: {
      handler: async function(val) {
        const { selectedEntityType } = this;
        this.loading = true;
        const resComp = await this.$http.get("assemble/api/v1/live/competitions", {
          params: {
            entityType: selectedEntityType,
            entityIds: val.join(','),
            season: this.filterSeason,
          }
        });
        this.competitions = resComp.data.data;
        this.competitionId = _.get(this.competitions[0], '_id', false);
        this.loading = false;
      },
    },
    // currentTab: {
    //   immediate: true,
    //   async handler(val) {
    //     const { competitionId } = this;

    //     if (val === 'ladder') {
    //       this.loading = true;
    //       this.ladder = {};
    //       const resLadder = await this.$httpNoAuth.get(`/assemble/api/v1/live/ladders/competition/${competitionId}`)
    //       this.ladder = Object.assign(this.ladder, resLadder.data.data)
    //     }
    //     this.loading = false;
    //   }
    // }
  }
};
</script>
<style scoped lang="scss">

ion-title {
  font-family: 'Cairo';
}

ion-grid {
  white-space: nowrap;
   --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
}

.header-bar {
  padding: 0.5rem;
}

.round-text {
  color: #fff;
  font-family: 'Cairo';
  text-align: center;
  font-size: 14px;
  text-transform: uppercase;
  // text-decoration: underline;
  // text-decoration-color: $highlight;
}

.competition-row {
  --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  background: $background !important;
}

.date-row {
  align-items: center;
  --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  padding: 1rem 1.5rem;
  background: $background !important;
  border-bottom: 1px solid #3a3a3a;
}

.chip {
  font-size: 1rem;
  color: #a9a9a9;
  font-family: 'Cairo';
  &.active {
    background: var(--highlight-color);

    color: #000;
    // color: var(--ion-color-primary);
    font-family: 'Cairo';
  }

  &.selectable {
    cursor: pointer;
    color: #a9a9a9;
    background: #1E1F22;
  }
}

.dateOption {
  display: flex;
  flex-direction: column;
  align-items: center;
  // gap: 0.25rem;
  span {
    color: #a9a9a9;
    font-size: 0.8rem;
    font-family: 'Cairo';
    transition: all 0.2s ease-in-out;
  }

  .date {
    font-size: 1rem;
  }

  &.active {
    // background: white;
    // color: var(--ion-color-primary);
    span {
      // font-size: 0.9rem;
      color: white !important;
      font-family: 'Cairo';
    }
  }

  &.selectable {
    cursor: pointer;
    color: #fff;
    // background: #1E1F22;
  }
}

.display-round-byes {
  font-size: 10px;
  color: rgba(255,196, 37, .9);
  padding: 5px;
  position: absolute;
  top: -30px;
  left: 20px;
  background: #1e1f22;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.display-round {
  font-size: 10px;
  color: rgba(255,196, 37, .9);
  padding: 5px;
  position: absolute;
  top: -32px;
  left: 40px;
  background: #1e1f22;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
ion-item {
  --padding-start: 15px;
  --padding-end: 15px;
}
.flex {
  display: flex;
}
.flex-column {
  flex-direction: column;
}
.align-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.light-text {
  font-size: 14px;
  font-weight: 400;
  text-transform: capitalize;
}
.normal-text {
  font-size: 15px;
  font-weight: 600;
  text-transform: capitalize;
}
.bold-text {
  font-size: 16px;
  font-weight: bold;
}
.score-text {
  font-size: 30px;
  line-height: 30px;
  font-weight: 700;
  /* color: rgba(8, 48, 109, 0.5); */
  color: white;
}

.header {
  --background: #1a2933 !important;
  color: white;
}

.custom-segment {
  background: $background !important;
}

.custom-segment ::before {
  border-left: none;
}

.custom-segment .segment-button-checked {
  color: $primary;
  --indicator-box-shadow: none;
  border-bottom: 2px solid $primary;
}

.bye-card {
  margin-inline: 1.5rem;
  position: relative;
  border-radius: 24px;
  cursor: pointer;
  // box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  // -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);

  font-family: 'BrownStd-Regular';
  color: white;
   box-shadow: none;
  background: #171717 !important;
  .round-text {
    margin-top: 0.5rem;
    margin-bottom: 1rem;
  }
}
.custom-card {
  border-radius: 24px;
  cursor: pointer;
  // box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  // -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  font-family: 'BrownStd-Regular';
  font-size: 1.2rem;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: white;
  // background: transparent;
   box-shadow: none;
  background: #171717 !important;
  margin-inline: 1.5rem;

  .venue {
    letter-spacing: -0.01rem;
  }
}
.custom-card .card-content-ios {
  padding: 10px;
}

.custom-card .promoted-header {
  font-family: 'BrownStd-Regular';
  text-align: center;
  font-size: .9rem;
  font-weight: 600;
  text-transform: capitalize;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: #2d3a45;
}

.list-ios, .list-md {
  padding: 0;
  background: 0;
}

ion-item {
  --background: #232528;
  --color: white;
}

.custom-segment ion-label {
  margin-bottom: 0;
}

ion-content {
  background: $background;
  --background: $background;
  --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
}

ion-content::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: rgba(0,0,0,0.3);
}

ion-content::-webkit-scrollbar
{
  width: .35rem;
  background-color: rgba(0,0,0,0.3);
}

@media only screen and (max-width: 768px) {
  ion-content::-webkit-scrollbar {
    width: .15rem;
    background-color: rgba(0,0,0,0.3);
  }
}

ion-content::-webkit-scrollbar-thumb
{
  background-color: #888;
}


.overlay {
  background: $background;
  // background: $primary;
  padding: 0rem;
}

ion-toolbar, ion-item {
  --border-width: 0 !important;
  --background: $background;
  --color: white;
}

ion-segment-button {
  --background-hover: white !important;
  --color-hover: $highlight !important;
  --color-checked: $highlight !important;
}

.custom-segment {
  border: none;
  /* background: white; */
  border-radius: 0px;
  border-bottom: 1px solid rgba(177, 177, 177, 0.3);
  padding-top: 1rem;
  border: none;
  background: none;
   display: flex;
  // justify-content: center;
  /* border-radius: 1rem !important; */
}

.custom-segment ::before {
  border-left: none;
}

.custom-segment .in-segment {
  color: rgba(177, 177, 177, 1);
  font-size: 1.3rem;
  // background-color: rgba($primary, .7);
}

.custom-segment .segment-button-checked {
  color: rgb(234 68 68);
  border-radius: 0;
  margin-bottom: 0;
  // background-color: rgba($primary, .7);
  color: $highlight;
  font-size: 1.3rem;
  font-weight: 500;
  --indicator-height: 0;
  --indicator-box-shadow: none;
  /* --indicator-color: rgb(234, 68, 68, 0.7);
  --indicator-transform:translate3d(0, 25px, 0) scale3d(.7,1,1); */
  border-bottom: 3px solid $highlight;
}
.custom-segment-ladder {
  // border: none;
  margin: 0 auto;
  margin-top: 1rem;
  display: flex;
  width:70%;
  justify-content: center;
  border-radius: 0.6rem !important;
}

.custom-segment-ladder-button{
  flex-basis: 50%;
}


.custom-segment-ladder ::before {
  border-left: none;
}

.custom-segment-ladder .in-segment {
  color: rgba(177, 177, 177, 1);
  background-color: rgba($primary, .2);
}

.custom-segment-ladder .segment-button-checked {
  color: rgb(234 68 68);
  // margin-bottom: 0;
  background-color: rgba($primary, .7);
  color: $highlight;
  font-weight: 400;
  // --indicator-height: 0;
  // --indicator-box-shadow: none;
  //  --indicator-color: rgb(234, 68, 68, 0.7);
  // --indicator-transform:translate3d(0, 25px, 0) scale3d(.7,1,1);
  // border-bottom: 3px solid $highlight;
}

.empty-container {
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.empty-container ion-card {
  padding: 4rem;
  border-radius: 1rem;
  background: transparent;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.empty-placeholder {
  align-items: flex-start;
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 137.4%;
  /* margin-bottom: 1rem; */
  padding-left: 0;

  letter-spacing: 0.02em;

  color: white;
}

.team-name {
  font-size: 0.8rem;
  white-space: break-spaces;
}

ion-select::part(icon) {
  margin-left: 0.5rem;
  color: white !important;
  opacity: 0.85;
}

@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0) {
  :host {
    padding-inline: 40px !important;
  }

}

</style>
